import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ComparisonValue } from "../BaseChartTools";
import { TooltipItem } from "./SecuritiesChartMobileTooltips";

interface UseSecuritiesTooltipsParams {
  x: number | undefined;
  formattedData: {
    name: string;
    data: [number, number][];
    color: string;
  }[];
  currentTicker?: ComparisonValue;
}

export const useSecuritiesTooltips = ({
  x,
  formattedData,
  currentTicker,
}: UseSecuritiesTooltipsParams): TooltipItem[] | undefined => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (x == null) {
      return undefined;
    }

    const newTooltips: TooltipItem[] = [];

    formattedData.forEach((series) => {
      const point = series.data.find(([pointX]) => pointX === x);

      if (point) {
        const [pointX, y] = point;
        const isComparisonSeries = series.name === "comparison";
        newTooltips.push({
          x: pointX,
          value: y,
          color: series.color,
          name: isComparisonSeries
            ? (currentTicker?.label ?? "")
            : t(
                `general.chart.securitiesChart.mobileHeaderValues.${series.name}`
              ),
        });
      }
    });

    return newTooltips.length ? newTooltips : undefined;
  }, [x, formattedData, currentTicker, t]);
};
